<div [formGroup]="group">
  @if (model.repeatable) {
    <div
      class="row"
      [attr.tabindex]="model.tabIndex"
      [id]="id"
      [formGroupName]="model.id"
      [ngClass]="model.layout.element?.control">
      @for (columnItems of items; track columnItems) {
        <div class="col-sm">
          @for (item of columnItems; track item) {
            <div  class="form-check">
              <input type="checkbox" class="form-check-input"
                [attr.aria-labelledby]="'label_' + model.id"
                [attr.tabindex]="item.index"
                [checked]="item.value"
                [id]="item.id"
                [formControlName]="item.id"
                [name]="model.name"
                [value]="item.value"
                (blur)="onBlur($event)"
                (change)="onChange($event)"
                (focus)="onFocus($event)"/>
              <label class="form-check-label"
                [class.disabled]="model.disabled"
                [ngClass]="model.layout.element?.control"
                [for]="item.id">
                <span [ngClass]="model.layout.element?.label" [innerHTML]="item.label"></span>
              </label>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (!model.repeatable) {
    <div
      class="row"
      ngbRadioGroup
      [attr.tabindex]="model.tabIndex"
      [id]="id"
      [ngClass]="model.layout.element?.control"
      (change)="onChange($event)">
      @for (columnItems of items; track columnItems) {
        <div class="col-sm">
          @for (item of columnItems; track item) {
            <div  class="form-check">
              <input type="radio" class="form-check-input"
                [checked]="item.value"
                [id]="item.id"
                [name]="model.id"
                [required]="model.required"
                [value]="item.index"
                (blur)="onBlur($event)"
                (focus)="onFocus($event)"/>
              <label class="form-check-label"
                [class.disabled]="model.disabled"
                [ngClass]="model.layout.element?.control"
                [for]="item.id">
                <span [ngClass]="model.layout.element?.label" [innerHTML]="item.label"></span>
              </label>
            </div>
          }
        </div>
      }
    </div>
  }
  @if ((isLoading$ | async)) {
    <div class="d-flex justify-content-center">
      <ds-loading></ds-loading>
    </div>
  }

</div>
